var map = {
	"./0.jpg": 1804,
	"./1.jpg": 8920,
	"./10.jpg": 5287,
	"./11.jpg": 1788,
	"./2.jpg": 9188,
	"./3.jpg": 8948,
	"./4.jpg": 1648,
	"./5.jpg": 1148,
	"./6.jpg": 6476,
	"./7.jpg": 5704,
	"./8.jpg": 1492,
	"./9.jpg": 7044
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5104;